//src/components/layout/NormexLogo.tsx
interface NormexLogoProps {
  collapsed?: boolean;
  className?: string;
}

export function NormexLogo({ collapsed = false, className = '' }: NormexLogoProps) {
  const logoSrc = collapsed ? '/favicon.ico' : '/logo-v3-branco.png';

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={logoSrc}
        alt="Normex"
        className={collapsed ? 'h-8 w-8 object-contain' : 'h-8 w-auto object-contain'}
      />
    </div>
  );
}
